import script from "./GachaAnimation.vue?vue&type=script&lang=ts&setup=true"
export * from "./GachaAnimation.vue?vue&type=script&lang=ts&setup=true"

import "./GachaAnimation.vue?vue&type=style&index=0&id=57533307&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57533307"]])

export default __exports__